import { createFileRoute } from '@tanstack/react-router';
import { OneOnOneLanding } from '@/features/one-on-one/OneOnOneLanding';

export const Route = createFileRoute('/_dashboard/one-on-one/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <OneOnOneLanding />;
}
